import(/* webpackMode: "eager", webpackExports: ["ModelsGridClient"] */ "/app/app/src/widgets/models/ui/ModelsGrid/ModelsGridClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModelsGridPagination"] */ "/app/app/src/widgets/models/ui/ModelsGrid/ModelsGridPagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
